import {TipoProjetoApropriacao} from './tipo-projeto-apropriacao.model';

export class TipoApropriacao {

  codigo: number;
  nome: string;
  aceitaDescricao: boolean;
  tipoProjeto: TipoProjetoApropriacao;
  aceitaValorDepreciacao: boolean;
  aceitaDataAquisicao: boolean;
  aceitaDataAluguel: boolean;

  constructor(init?: Partial<TipoApropriacao>) {
    Object.assign(this, init);
  }
}
